<template>
  <div>
    <v-container class="pt-0">
      <span class="headline">{{$t('impress.title')}}</span>
      <v-row>
        <v-col cols="12">
          <span>{{$t('impress.espocial-is-a-product-of', {product: $tenant.title})}}</span>
          <static-content which="legal-notice" class="mt-2"/>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" sm="12" class="py-1">
          <v-btn @click="function() {showDialog.agb = true;}" class="secondary darken-3">
            <v-icon left>mdi-open-in-app</v-icon>{{$t('registration.show-legals')}}
          </v-btn>
          <aGBDialog
            :visible="showDialog.agb"
            :closeAction="function() {showDialog.agb = false;}"
          />
        </v-col>
        <v-col cols="12" sm="12" class="py-1">
          <v-btn
            @click="function() {showDialog.privacyPolicy = true;}"
            class="secondary darken-3"
          >
            <v-icon left>mdi-open-in-app</v-icon>{{$t('registration.show-privacy-policy')}}
          </v-btn>
          <privacy-policy-dialog
            :visible="showDialog.privacyPolicy"
            :closeAction="function() {showDialog.privacyPolicy = false;}"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="
          ($store.state.env.global.backendEnv &&
          $store.state.env.global.backendEnv != 'production') || (isSuperUser())
        "
      >
        <v-col cols="12">
          <span class="subtitle-1">weitere Infos</span>
          <br />
          Backend-Umgebung: {{ $store.state.env.global.backendEnv }}
          <br />
          Backend-Name: {{ $store.state.env.global.backendName }}
        </v-col>
        <v-col cols="12">
          <v-btn link to="/devTools">
            <v-icon left>mdi-developer-board</v-icon>DevTools
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AGBDialog from "@/widgets/AGBDialog";
import PrivacyPolicyDialog from "@/widgets/PrivacyPolicyDialog";
import StaticContent from "@/widgets/StaticContent"
import envMixin from "@/mixins/envMixin"

export default {
  name: "Home",
  mixins: [envMixin],
  components: {
    StaticContent,
    AGBDialog,
    PrivacyPolicyDialog,
  },

  data: function() {
    return {
      showDialog: {
        agb: false,
        privacyPolicy: false
      },
    }
  },
};
</script>
